import React from "react";
import { Home, Gavel, ListChecks, Wallet, User, LifeBuoy } from "lucide-react";
import DashboardLayout from "../../components/dashboard/DashboardLayout";

const ITEMS = [
  { to: "/vendor/dashboard", label: "Dashboard", icon: Home, end: true },
  { to: "/vendor/bidding", label: "Live Bidding", icon: Gavel },
  { to: "/vendor/orders", label: "Orders", icon: ListChecks },
  { to: "/vendor/earnings", label: "Earnings", icon: Wallet },
  { to: "/vendor/profile", label: "Profile", icon: User },
  { to: "/vendor/support", label: "Support", icon: LifeBuoy },
];

export default function VendorLayout() {
  return <DashboardLayout items={ITEMS} title="Vendor" />;
}
